
































































import Vue from 'vue';
import massClient from '../../apis';
import Image from '../../models/Image';
import { SSL_OP_NETSCAPE_CHALLENGE_BUG } from 'constants';

const image: Image | null = null;

export default Vue.extend({
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    oldImage: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      showImageBox: true,
      current: 1,
      total: 0,
      pageSize: 10,
      listData: [],
      loadImageFinished: false,
      image,
    };
  },
  mounted() {
    this.loadImages();
    if (this.oldImage) {
      this.image = this.oldImage;
    }
  },
  methods: {
    changePage(page: number) {
      if (this.current !== page) {
        this.current = page;
        this.loadImages();
      }
    },
    loadImages() {
      this.loadImageFinished = false;
      massClient.getImages({
        page: this.current,
        size: this.pageSize,
      }).success((r) => {
        this.listData = r.data;
        this.total = r.total;
        this.loadImageFinished = true;
      });
    },
    selectImage(image: Image) {
      if (this.image && this.image.id === image.id) {
        this.image = null;
      } else {
        this.image = image;
      }
    },
    close() {
      this.$emit('close');
    },
    confirmImage() {
      this.$emit('confirm', this.image);
    },
  },
});
